module.exports = __webpack_public_path__ + "static/img/elegantMannersBig3.cc7c191d.png";